module.exports = __webpack_public_path__ + "img/hc_pro_two_7.ef076154.jpg";